import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import type { JSX } from 'react';
import TabMode from '../Enums/TabMode';
import VesselsTab from '../Tabs/VesselsTab/VesselsTab';
import SettingsTab from '../Tabs/SettingsTab/SettingsTab';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear, faNoteSticky } from '@fortawesome/free-solid-svg-icons';
import { updateLastActivity } from '../Utils/LastActivity';
import type { UserContextProps } from '../Contexts/UserContext';
import UserContext from '../Contexts/UserContext';
import type { LocalStorageContextProps } from '../Contexts/LocalStorageContext';
import LocalStorageContext from '../Contexts/LocalStorageContext';
import { navBarHeight } from '../Constants';
import type { NavigateFunction} from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

type MainPageProps = {
    tabMode: TabMode,
    subView: string | null,
};

function MainPage(props: Readonly<MainPageProps>): JSX.Element {

    const userContext: UserContextProps = useContext<UserContextProps>(UserContext);
    const localStorageContext: LocalStorageContextProps = useContext<LocalStorageContextProps>(LocalStorageContext);

    const navigate: NavigateFunction = useNavigate();

    const [windowSize, setWindowSize] = useState<[number, number]>([1920, 1080]);

    const mainRenderBody: JSX.Element = useMemo<JSX.Element>(() => {

        if (props.tabMode === TabMode.VESSELS) {
            return <VesselsTab />; 

        } else if (props.tabMode === TabMode.SETTINGS) {
            return <SettingsTab openedSubTab={props.subView} />; 

        } else { //should not happen
            return <VesselsTab />;
        }
    }, [props.subView, props.tabMode]);

    const bottonNavigationValue: string = useMemo<string>(() => {

        if (props.tabMode === TabMode.VESSELS) {
            return '/vessels'; 

        } else if (props.tabMode === TabMode.SETTINGS) {
            return '/settings'; 

        } else { //should not happen
            return '/vessels';
        }
    }, [props.tabMode]);

    useEffect(() => {

        function updateSize(): void {
            setWindowSize([window.innerWidth, window.innerHeight]);
        }

        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);

    return (
        <div>
            <div style={{
                height: windowSize[1] - navBarHeight,
                overflow: 'auto',
            }}>
                {mainRenderBody}
            </div>
            <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
                <BottomNavigation
                    showLabels
                    value={bottonNavigationValue}
                    onChange={(event: React.SyntheticEvent, newRoute: string): void => {
                        updateLastActivity(userContext, localStorageContext);
                        navigate(newRoute);
                    }}
                    style={{
                        height: navBarHeight,
                    }}
                >
                    <BottomNavigationAction value={'/vessels'} label='Vessels' icon={<FontAwesomeIcon icon={faNoteSticky} size='xl' />} />
                    <BottomNavigationAction value={'/settings'} label='Settings' icon={<FontAwesomeIcon icon={faGear} size='xl' />} />
                </BottomNavigation>
            </Paper>
        </div>
    );
}

export default MainPage;